export default "__VITE_PUBLIC_ASSET__f75abedc__"